import Link from "next/link";
import { LoadingRippleFullscreen } from "@/components/ui/LoadingRipple";
import WrapExperienceCard from "@/components/ui/WrapExperienceCard/WrapExperienceCard";
import WrapExperienceCardContext from "@/components/ui/WrapExperienceCard/WrapExperienceContext";
import { trpc } from "@/services/Trpc/client";

import CardListItem from "./CardListItem";

export const CardList = ({
  state,
  filter,
}: {
  filter: string;
  state: "DRAFT" | "SENT";
}) => {
  const { isLoading, data: cards, error } = trpc.card.list.useQuery({});

  if (isLoading) return <LoadingRippleFullscreen />;
  if (error) {
    console.error(error);
    return <div>Error: {JSON.stringify(error)}</div>;
  }

  const list = cards
    .filter((card) => card.name.toLowerCase().includes(filter.toLowerCase()))
    .filter((card) => card.state === state)
    .sort((a, b) => {
      if (!a?.updatedAt) return 1;
      if (!b?.updatedAt) return -1;
      return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();
    })
    .map((card) => {
      return <CardListItem key={card?.id} card={card} />;
    });

  return (
    <>
      {state === "DRAFT" && (
        <WrapExperienceCardContext.Provider
          value={{
            card: { thumbnailURL: "+ icon.png", author: undefined, name: "" },
          }}
        >
          <Link href="/">
            <div className="relative flex justify-center overflow-visible">
              <div className="aspect-9/16 group flex max-h-[70vh] w-full flex-col  overflow-hidden rounded-2xl bg-white shadow-md">
                <WrapExperienceCard.Image />

                <div
                  className={`bg-wg-purple relative bottom-0  space-y-2 whitespace-nowrap px-2 py-2 md:px-4 md:py-4`}
                >
                  <div className="flex grow justify-center space-x-1 md:space-x-4">
                    <div className="text-wrap font-spaceGrotesk flex whitespace-normal text-center font-bold text-white md:text-lg">
                      Create A Card
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </WrapExperienceCardContext.Provider>
      )}
      {list}
    </>
  );
};
